module.exports = __webpack_public_path__ + "static/media/MadeInFrance_ombre.370fa574.png";